
<div class="table-responsive margin-top-15 table-view">
    <h5 class="table-title">Action Priority</h5>
    <button [disabled]="DisableExport" class="btn btn-primary primary-btn button-excel"  style="margin-bottom: 10px;" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o"></i>Export To Excel</button>
    <p-table [value]="ActionPriorityData" dataKey="id" editMode="row" id="ActionPriorityTableToExport">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:220px">Base Unit</th>
          <th class="center-table">Low</th>
          <th class="center-table">Medium</th>
          <th class="center-table">High</th>
          <th class="center-table">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-actionPriority
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="actionPriority">
          <td style="width:220px">
            {{ actionPriority.category }}
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="actionPriority.Low"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetActionPrioritySelectedDetails(actionPriority.UnitId,actionPriority.category,1)" data-target="#AT"> {{ actionPriority.Low }}</a> 
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="actionPriority.Medium"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetActionPrioritySelectedDetails(actionPriority.UnitId,actionPriority.category,2)" data-target="#AT"> {{ actionPriority.Medium }}</a> 
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="actionPriority.High"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetActionPrioritySelectedDetails(actionPriority.UnitId,actionPriority.category,3)" data-target="#AT"> {{ actionPriority.High }}</a> 
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(actionPriority)"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(actionPriority)"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(actionPriority, ri)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of ACTPrData; let i=index">
            <li><a (click)="Redirect(item.value,item.ID)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="ACTPrData?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>

